var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Steps", { attrs: { "current-page": 5 } }),
      _c("div", { staticClass: "container container-medium" }, [
        _c("div", { staticClass: "text-center heading-wrapper" }, [
          _c("span", { staticClass: "heading" }, [
            _vm._v(_vm._s(_vm.$t("btn_choose_payment_method"))),
          ]),
        ]),
        _c("div", { staticClass: "purchase-wrapper" }, [
          _c("div", { staticClass: "text-center" }, [
            _c("span", { staticClass: "main-text" }, [
              _vm._v(_vm._s(_vm.$t("order_step5"))),
            ]),
          ]),
        ]),
      ]),
      _vm.selectedProfile
        ? _c(
            "div",
            { staticClass: "container container-xs mt-4" },
            [
              _c("p", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("label_billing_type")) + ":"),
                ]),
              ]),
              _vm.selectedProfile.billing_type == "pf"
                ? [
                    _c("span", [
                      _c("strong", [_vm._v(_vm._s(_vm.$t("type")))]),
                      _vm._v(": " + _vm._s(_vm.$t("individual_person"))),
                    ]),
                    _c("br"),
                    _vm.selectedProfile.last_name ||
                    _vm.selectedProfile.first_name
                      ? _c("span", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("label_first_name"))),
                          ]),
                          _vm._v(
                            ": " +
                              _vm._s(_vm.selectedProfile.last_name) +
                              " " +
                              _vm._s(_vm.selectedProfile.first_name)
                          ),
                        ])
                      : _vm._e(),
                    _c("br"),
                    _vm.selectedProfile.fiscal_or_address
                      ? _c("span", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("label_address"))),
                          ]),
                          _vm._v(
                            ": " + _vm._s(_vm.selectedProfile.fiscal_or_address)
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.selectedProfile.billing_type == "pj"
                ? [
                    _c("span", [
                      _c("strong", [_vm._v(_vm._s(_vm.$t("type")))]),
                      _vm._v(": " + _vm._s(_vm.$t("juridical_person"))),
                    ]),
                    _c("br"),
                    _vm.selectedProfile.company
                      ? _c("span", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("label_company_name"))),
                          ]),
                          _vm._v(": " + _vm._s(_vm.selectedProfile.company)),
                        ])
                      : _vm._e(),
                    _c("br"),
                    _vm.selectedProfile.fiscal_code
                      ? _c("span", [
                          _c("strong", [_vm._v(_vm._s(_vm.$t("label_cui")))]),
                          _vm._v(
                            ": " + _vm._s(_vm.selectedProfile.fiscal_code)
                          ),
                        ])
                      : _vm._e(),
                    _c("br"),
                    _vm.selectedProfile.j_code
                      ? _c("span", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("label_reg_com"))),
                          ]),
                          _vm._v(": " + _vm._s(_vm.selectedProfile.j_code)),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      !_vm.loading
        ? [
            _c(
              "div",
              { staticClass: "container container-xs" },
              [
                _c("Alerts", {
                  attrs: {
                    "alert-type": _vm.alertType,
                    "alert-color": "danger",
                  },
                }),
                _vm._l(_vm.availablePaymentMethods(), function (item, key) {
                  return (item.id != 8 && item.id != 10) ||
                    (item.id == 8 && _vm.hasCreditInstantActivated) ||
                    (item.id == 10 && _vm.hasInstantDebitActivated)
                    ? _c(
                        "div",
                        {
                          key: key,
                          staticClass: "text-left my-4",
                          class: [
                            {
                              "card-primary": _vm.method == item.id,
                              "bg-danger text-white":
                                (item.id == 8 &&
                                  !_vm.instantCreditAvailableAmount()) ||
                                (item.id == 10 &&
                                  !_vm.instantDebitAvailableAmount()) ||
                                (item.id == 1 && !_vm.checkIfAllowedOP()),
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.chooseMethod(item.id)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "paymentMethod",
                              class: { selected: _vm.method == item.id },
                            },
                            [
                              _vm.method == item.id
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "elipse-complete position-absolute margin-minus",
                                    },
                                    [_c("div", { staticClass: "icon v-icon" })]
                                  )
                                : _vm._e(),
                              _c("strong", { staticClass: "payment-name" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                              item.id == 1 && !_vm.checkIfAllowedOP()
                                ? _c("p", [_vm._v(_vm._s(_vm.opErrorMsg))])
                                : _vm._e(),
                              item.id == 8 &&
                              !_vm.instantCreditAvailableAmount()
                                ? _c("span", [
                                    _vm._v(
                                      " - " +
                                        _vm._s(
                                          _vm.$t(
                                            "payment_method_insuficient_credit"
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              item.id == 10 &&
                              !_vm.instantDebitAvailableAmount()
                                ? _c("span", [
                                    _vm._v(
                                      " - " +
                                        _vm._s(
                                          _vm.$t(
                                            "payment_method_insuficient_debit"
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass: "amount",
                                  class: [
                                    {
                                      "text-white":
                                        item.id == 8 &&
                                        !_vm.instantCreditAvailableAmount(),
                                    },
                                  ],
                                },
                                [
                                  _c("p", { staticClass: "m-0 reading" }, [
                                    _vm._v(_vm._s(item.description)),
                                  ]),
                                  item.id == 1 && item.id == _vm.method
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "p-3 reading" },
                                          [
                                            _c("span", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("warning"))
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("warning_txt_1")
                                                  )
                                              ),
                                            ]),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("warning_txt_2"))
                                              ),
                                            ]),
                                            _c("br"),
                                            _c("br"),
                                            _c("span", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("warning"))
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("warning_txt_3")
                                                  )
                                              ),
                                            ]),
                                            _c("br"),
                                            _c("br"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("warning_txt_4"))
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        item.id == 7 && _vm.method == item.id,
                                      expression:
                                        "item.id == 7 && method == item.id",
                                    },
                                  ],
                                  staticClass: "mt-3",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex",
                                      attrs: { id: "itranfer" },
                                    },
                                    [
                                      !_vm.disabledPaymentMethods.includes("BT")
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.chooseiTransferBank(
                                                    "ITRANSFER_BT"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.iTransfer,
                                                    expression: "iTransfer",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  value: "ITRANSFER_BT",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.iTransfer,
                                                    "ITRANSFER_BT"
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.iTransfer =
                                                      "ITRANSFER_BT"
                                                  },
                                                },
                                              }),
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../assets/media/bt.png"),
                                                  alt: "BT",
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.disabledPaymentMethods.includes(
                                        "BCR"
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center ml-4",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.chooseiTransferBank(
                                                    "ITRANSFER_BCR"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.iTransfer,
                                                    expression: "iTransfer",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "radio",
                                                  value: "ITRANSFER_BCR",
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.iTransfer,
                                                    "ITRANSFER_BCR"
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.iTransfer =
                                                      "ITRANSFER_BCR"
                                                  },
                                                },
                                              }),
                                              _c("img", {
                                                attrs: {
                                                  src: require("../../assets/media/bcr.png"),
                                                  alt: "BCR",
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.$store.getters["auth/getLoginStatus"] &&
                              item.id == 8 &&
                              _vm.hasCreditInstantActivated
                                ? _c(
                                    "div",
                                    { staticClass: "reading" },
                                    [
                                      _vm.selectedProfile.has_instant_credit
                                        ? [
                                            _c("br"),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "amount",
                                                class: [
                                                  {
                                                    "text-white":
                                                      item.id == 8 &&
                                                      !_vm.instantCreditAvailableAmount(),
                                                  },
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "payment_method_credit_erv"
                                                      )
                                                    ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.selectedProfile.instant_limit_amount.toFixed(
                                                        2
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$tc(
                                                        "currency",
                                                        _vm.selectedProfile
                                                          .instant_limit_amount
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm.selectedProfile.has_instant_credit_tpf
                                        ? [
                                            _c("br"),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "amount",
                                                class: [
                                                  {
                                                    "text-white":
                                                      item.id == 8 &&
                                                      !_vm.instantCreditAvailableAmount(),
                                                  },
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "payment_method_credit_tpf"
                                                      )
                                                    ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.selectedProfile.instant_limit_tpf_amount.toFixed(
                                                        2
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$tc(
                                                        "currency",
                                                        _vm.selectedProfile
                                                          .instant_limit_tpf_amount
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.$store.getters["auth/getLoginStatus"] &&
                              item.id == 10 &&
                              _vm.hasInstantDebitActivated
                                ? _c(
                                    "div",
                                    { staticClass: "reading" },
                                    [
                                      _vm.selectedProfile.has_instant_debit
                                        ? [
                                            _c("br"),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "amount",
                                                class: [
                                                  {
                                                    "text-white":
                                                      item.id == 10 &&
                                                      !_vm.instantDebitAvailableAmount(),
                                                  },
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "payment_method_debit_erv"
                                                      )
                                                    ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.selectedProfile.instant_debit_limit_amount.toFixed(
                                                        2
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$tc(
                                                        "currency",
                                                        _vm.selectedProfile
                                                          .instant_debit_limit_amount
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm.selectedProfile.has_instant_debit_tpf
                                        ? [
                                            _c("br"),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "amount",
                                                class: [
                                                  {
                                                    "text-white":
                                                      item.id == 10 &&
                                                      !_vm.instantDebitAvailableAmount(),
                                                  },
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "payment_method_debit_tpf"
                                                      )
                                                    ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.selectedProfile.instant_debit_limit_tpf_amount.toFixed(
                                                        2
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.$tc(
                                                        "currency",
                                                        _vm.selectedProfile
                                                          .instant_debit_limit_tpf_amount
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              item.id == 2 &&
                              _vm.loginStatus &&
                              _vm.method == item.id
                                ? _c(
                                    "div",
                                    { staticClass: "mt-3 tokens" },
                                    [
                                      _vm.tokens != null && _vm.tokens.length
                                        ? [
                                            _c("div", { staticClass: "mb-3" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "payment_method_credit_erv"
                                                  )
                                                ) + ":"
                                              ),
                                            ]),
                                            _vm._l(
                                              _vm.tokens,
                                              function (t, key) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: key,
                                                    staticClass:
                                                      "form-group mb-0",
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass: "pointer",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.tokenId,
                                                              expression:
                                                                "tokenId",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                          },
                                                          domProps: {
                                                            value: t.id,
                                                            checked: _vm._q(
                                                              _vm.tokenId,
                                                              t.id
                                                            ),
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              _vm.tokenId = t.id
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "ml-2 mr-2",
                                                          },
                                                          [
                                                            t.cardType ==
                                                            "Mastercard"
                                                              ? _c("img", {
                                                                  attrs: {
                                                                    src: require("../../media/mastercard.svg"),
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            t.cardType == "Visa"
                                                              ? _c("img", {
                                                                  attrs: {
                                                                    src: require("../../media/visa.png"),
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              t.cardNumberMask
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "form-group mb-0" },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "pointer" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.tokenId,
                                                    expression: "tokenId",
                                                  },
                                                ],
                                                attrs: { type: "radio" },
                                                domProps: {
                                                  value: null,
                                                  checked: _vm._q(
                                                    _vm.tokenId,
                                                    null
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.tokenId = null
                                                  },
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "ml-3 reading" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("new_card"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.tokenId == null
                                        ? _c(
                                            "div",
                                            { staticClass: "form-group mb-0" },
                                            [
                                              _c(
                                                "label",
                                                { staticClass: "pointer" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.saveCard,
                                                        expression: "saveCard",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      value: true,
                                                      checked: Array.isArray(
                                                        _vm.saveCard
                                                      )
                                                        ? _vm._i(
                                                            _vm.saveCard,
                                                            true
                                                          ) > -1
                                                        : _vm.saveCard,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a = _vm.saveCard,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = true,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.saveCard =
                                                                $$a.concat([
                                                                  $$v,
                                                                ]))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.saveCard =
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                          }
                                                        } else {
                                                          _vm.saveCard = $$c
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "ml-3 reading",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "add_card_for_next_transactions"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    : _vm._e()
                }),
                _vm.errorMsgs.acceptancePayment && !_vm.acceptancePayment
                  ? _c("span", { staticClass: "invalid-feedback" }, [
                      _vm._v(
                        " " + _vm._s(_vm.errorMsgs.acceptancePayment) + " "
                      ),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "form-group form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.acceptancePayment,
                        expression: "acceptancePayment",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      name: "acceptancePayment",
                      id: "acceptancePayment",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.acceptancePayment)
                        ? _vm._i(_vm.acceptancePayment, null) > -1
                        : _vm.acceptancePayment,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.acceptancePayment,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.acceptancePayment = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.acceptancePayment = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.acceptancePayment = $$c
                        }
                      },
                    },
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "accept-terms ml-2",
                      attrs: { for: "acceptancePayment" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("payment_method_terms")) + " "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "link reading",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.openModal("termsModal")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("new_account_tc")) + " ")]
                      ),
                      _vm._v(" " + _vm._s(_vm.$t("and")) + " "),
                      _c(
                        "a",
                        {
                          staticClass: "link",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.openModal("confidentialityModal")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("new_account_pc")) + " ")]
                      ),
                    ]
                  ),
                ]),
                _vm.recaptchaError != null
                  ? _c(
                      "div",
                      {
                        staticClass: "alert alert-danger text-center",
                        attrs: { id: "recaptcha-error" },
                      },
                      [_vm._v(" " + _vm._s(_vm.recaptchaError) + " ")]
                    )
                  : _vm._e(),
                _c("div", { attrs: { id: "recaptcha-container" } }),
                _c(
                  "div",
                  [
                    _c("PaymentMethodButtons", {
                      attrs: { "valid-terms": _vm.acceptancePayment == true },
                      on: { placeOrder: _vm.placeOrder },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "modal", attrs: { id: "termsModal", tabindex: "-1" } },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("terms"))),
                ]),
                _vm._m(0),
              ]),
              _c(
                "div",
                { staticClass: "modal-body px-0" },
                [_c("terms", { attrs: { "in-modal": true } })],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c("div", { staticClass: "d-flex justify-content-end" }, [
                  _c(
                    "button",
                    {
                      staticClass: "main-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.f_agreeTC()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("btn_i_understand")) + " ")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: { id: "confidentialityModal", tabindex: "-1" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v(_vm._s(_vm.$t("new_account_pc"))),
                ]),
                _vm._m(1),
              ]),
              _c(
                "div",
                { staticClass: "modal-body px-0" },
                [_c("confidentiality", { attrs: { "in-modal": true } })],
                1
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c("div", { staticClass: "d-flex justify-content-end" }, [
                  _c(
                    "button",
                    {
                      staticClass: "main-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.f_agreePC()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("btn_i_understand")) + " ")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("div", { staticClass: "icon icon-x" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("div", { staticClass: "icon icon-x" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }